import { useTranslation } from "react-i18next";
import { languages } from "../data/languages";

export default function Languages() {
  const { t, i18n } = useTranslation('translation', { useSuspense: false });
  return (
    <section className="section">
      <h2>{t('title.languages')}</h2>
      <ul>
        {languages[i18n.language].map((language) => (
          <li key={language}>
            {language}
          </li>
        ))}
      </ul>
    </section>
  );
}
